import moment from "moment";

export const columns = [
  {
    accessorKey: "sNo",
    header: "Serial #",
    flex: 1,
    accessorFn: (row: any, index: any) => index + 1,
  },
  {
    accessorKey: "createdOn",
    header: "Date & Time",
    flex: 1,
    accessorFn: function customCell(row: any) {
      return `${row.createdOn ? moment(row.createdOn).format("DD-MM-YYYY hh:mm:ss A") : ""}`;
    },
  },
  {
    accessorKey: "transactionType",
    header: "Transaction Type",
    flex: 1,
    accessorFn: (row: any) => ` ${row.transactionType === 1 ? "Receive" : "Issue" || " "}`,
  },
  {
    accessorKey: "quantity",
    header: "Quantity",
    flex: 1,
    accessorFn: (row: any) =>
      ` ${row.quantity || 0} ${
        row.weightUnit ? (row.weightUnit == "Cubic meter" ? "m³" : row.weightUnit) : "Kg"
      }`,
  },
  {
    accessorKey: "accumulative",
    header: "Accumulative",
    flex: 1,
    accessorFn: (row: any) =>
      ` ${row.accumulative || 0} ${
        row.weightUnit ? (row.weightUnit == "Cubic meter" ? "m³" : row.weightUnit) : "Kg"
      }`,
  },
  {
    accessorKey: "byFrom",
    header: "By/From",
    flex: 1,
    accessorFn: (row: any) => ` ${row.supplierType || " "} - ${row.byFrom || " "}`,
  },
];
